import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import moment from 'moment';
import React from 'react';
import { CloseButton, Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationListStandalone, PaginationProvider } from 'react-bootstrap-table2-paginator';
import { Link } from "react-router-dom";
import '../../App.css';
import { Constants } from "../../constants";
import SiteMenu from "../menu";
import ReactGA from "react-ga4";

function dateFormat(value, row, index) {
    return moment(value).format('MM/DD/YYYY');
}

function currencyFormat(num) {
    return '$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
function creditCurrencyFormatBold(num) {
    return (<Form.Label style={{ fontWeight: 'bold', color: '#00973A' }}>{'$' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')}</Form.Label>);
}
function creditCurrencyFormat(num) {
    return '$' + (-1 * num).toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
}
class ViewOpenInvoices extends React.Component {
    constructor(props) {
        super(props);

        let userExists = !(props.location.state == null || props.location.state.user == null);

        this.state = {
            user: userExists ? props.location.state.user : {},
            account: props.location.state.account,
            page: 1,
            creditData: [],
            filteredCreditData: [],
            selectedCredits: [],
            selectedCreditIds: [],
            data: [],
            filteredData: [],
            totalSize: 0,
            sizePerPage: 10,
            selected: [],
            selectedIds: [],
            selectedTotal: 0,
            searchTerm: '',
            filterEntityType: 'Boland',
            loading: false,
            creditLoading: false,
            emptyText: 'No open Boland invoices.',
            emptyCreditText: 'No open credits.'
        };

        this.handlePaySelected = this.handlePaySelected.bind(this);

        this.customSort = this.customSort.bind(this);
        this.handleSelect = this.handleSelect.bind(this);
        this.handleClear = this.handleClear.bind(this);
        this.handleClearSearch = this.handleClearSearch.bind(this);
        this.handleTableChange = this.handleTableChange.bind(this);
        this.handleSelectAll = this.handleSelectAll.bind(this);
        this.showButton = this.showButton.bind(this);

        this.handleDownloadSelected = this.handleDownloadSelected.bind(this);


        this.handleCreditTableChange = this.handleCreditTableChange.bind(this);
        this.handleCreditSelect = this.handleCreditSelect.bind(this);
        this.handleCreditSelectAll = this.handleCreditSelectAll.bind(this);
        this.handleCreditDownloadSelected = this.handleCreditDownloadSelected.bind(this);
        this.showButtonCredits = this.showButtonCredits.bind(this);
        this.handleApplyCredits = this.handleApplyCredits.bind(this);
        this.creditTableRef = React.createRef();


        this.showCSVButton = this.showCSVButton.bind(this);
        this.downloadCSV = this.downloadCSV.bind(this);


        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.handleSearch = this.handleSearch.bind(this);


        this.tableRef = React.createRef();
        this.filterText = React.createRef();
    }

    componentDidMount() {
        this.handleTableChange("None", this.state);
        this.handleCreditTableChange("None", this.state);
    }

    handleFilterChange(event) {
        this.setState({
            filterEntityType: event.target.value,
            emptyText: 'No open ' + event.target.value + ' invoices.'
        }, () => {
            this.handleTableChange("None", this.state);
        });
    }
    handleClear(event) {
        event.preventDefault();
        this.filterText.current.value = '';
        this.setState({
            searchTerm: '',
            selected: [],
            selectedIds: [],
            page: 1
        }, function () {
            this.handleTableChange("None", { page: 1, sizePerPage: 10 });
        });
    }

    handleClearSearch(event) {
        event.preventDefault();
        console.log('here');
        this.filterText.current.value = '';
        this.setState({
            searchTerm: '',
            filteredData: this.state.data.sort(this.customSort)
        });
    }

    handleSearch(event) {
        event.preventDefault();
        this.state.page = 1;
        this.handleTableChange("None", this.state);
    }

    handleSearchChange(event) {
        let invoiceNumbers = this.state.selected.map(function (item) {
            return item['DocumentNumber'];
        });

        let xyz = this.state.data.filter(function (row) {
            if (row['PONumber'].toLowerCase().includes(event.target.value.toLowerCase())) return true;
            if (row['DocumentNumber'].toLowerCase().includes(event.target.value.toLowerCase())) return true;
            if (row['BuildingName'] != null && row['BuildingName'].toLowerCase().includes(event.target.value.toLowerCase())) return true;
            if (invoiceNumbers.includes(row['DocumentNumber'])) return true;
            return false;
        }).map(function (obj) {
            obj['isSelected'] = invoiceNumbers.includes(obj['DocumentNumber']);
            return obj;
        });

        this.setState({
            searchTerm: event.target.value,
            filteredData: xyz.sort(this.customSort)
        });
    }

    customSort(objA, objB) {
        if (objA.isSelected != objB.isSelected) {
            return objA.isSelected ? -1 : 1;
        }

        if (moment(objA['DocumentDate']) > moment(objB['DocumentDate'])) {
            return 1;
        }
        else if (moment(objA['DocumentDate']) < moment(objB['DocumentDate'])) {
            return -1;
        }
        return 0;
    }

    handleSelect = (row, isSelect) => {
        let allow = true;
        let selected = [];
        if (isSelect) {
            if (this.state.selected.length >= 25) {
                selected = this.state.selected;
                alert('Maximum selected invoices reached (25).');
                allow = false;
            }
            else {
                selected = [...this.state.selected, row];
            }
        } else {
            selected = this.state.selected.filter(x => x.InvoiceKey !== row.InvoiceKey);
            allow = false;
        }

        let invoiceNumbers = selected.map(function (item) {
            return item['DocumentNumber'];
        });

        let xyz = this.state.data.filter(function (row) {
            if (row['PONumber'].toLowerCase().includes(this.state.searchTerm.toLowerCase())) return true;
            if (row['DocumentNumber'].toLowerCase().includes(this.state.searchTerm.toLowerCase())) return true;
            if (invoiceNumbers.includes(row['DocumentNumber'])) return true;
            return false;
        }, this).map(function (obj) {
            obj['isSelected'] = invoiceNumbers.includes(obj['DocumentNumber']);
            return obj;
        });

        this.setState(() => ({
            selected: selected,
            selectedIds: selected.map(r => r.InvoiceKey),
            selectedTotal: selected.map(item => item.BalanceDue).reduce((prev, curr) => prev + curr, 0),
            filteredData: xyz.sort(this.customSort)
        }));
    }

    handleCreditSelect = (row, isSelect) => {
        let allow = true;
        let selected = [];
        if (isSelect) {
            if (this.state.selectedCredits.length >= 25) {
                selected = this.state.selectedCredits;
                alert('Maximum selected credits reached (25).');
                allow = false;
            }
            else {
                selected = [...this.state.selectedCredits, row];
            }
        } else {
            selected = this.state.selectedCredits.filter(x => x.PaymentKey !== row.PaymentKey);
            allow = false;
        }

        let paymentNumbers = selected.map(function (item) {
            return item['PaymentNumber'];
        });

        let xyz = this.state.creditData.filter(function (row) {
            if (row['PaymentNumber'].toLowerCase().includes(this.state.searchTerm.toLowerCase())) return true;
            if (paymentNumbers.includes(row['PaymentNumber'])) return true;
            return false;
        }, this).map(function (obj) {
            obj['isSelected'] = paymentNumbers.includes(obj['DocumentNumber']);
            return obj;
        });

        this.setState(() => ({
            selectedCredits: selected,
            selectedCreditIds: selected.map(r => r.PaymentKey),
            filteredCreditData: xyz.sort(this.customSort)
        }));
    }

    handleSelectAll = (isSelect, rows) => {
        if (isSelect) {
            let selectedRows = rows.slice(0, 25);
            this.setState(() => ({
                selected: selectedRows,
                selectedTotal: selectedRows.map(item => item.BalanceDue).reduce((prev, curr) => prev + curr, 0),
                selectedIds: selectedRows.map(r => r.InvoiceKey)
            }));
            if (selectedRows.length == 25) {
                alert('Maximum selected invoices reached (25).');
            }
            return selectedRows.map(r => r.InvoiceKey);
        } else {
            this.setState(() => ({
                selected: [],
                selectedIds: [],
                selectedTotal: 0,
                filteredData: this.state.data
            }));
            return [];
        }
    }

    handleCreditSelectAll = (isSelect, rows) => {
        if (isSelect) {
            let selectedRows = rows.slice(0, 25);
            this.setState(() => ({
                selectedCredits: selectedRows,
                selectedCreditIds: selectedRows.map(r => r.PaymentKey)
            }));
            if (selectedRows.length == 25) {
                alert('Maximum selected credits reached (25).');
            }
            return selectedRows.map(r => r.InvoiceKey);
        } else {
            this.setState(() => ({
                selectedCredits: [],
                selectedCreditIds: [],
                filteredCreditData: this.state.creditData
            }));
            return [];
        }
    }

    handlePaySelected(event) {
        event.preventDefault();

        let invoiceKeys = [];
        let prelimTotal = 0;
        if (this.state.selected.length == 0) { return; }
        for (let i = 0; i < this.state.selected.length; i++) {
            prelimTotal += this.state.selected.BalanceDue;
            if (this.state.selected[i].InvoiceStatus != "Past due" && this.state.selected[i].InvoiceStatus != "Outstanding") {
                alert("Payment has already been received for the selected pending invoice(s).");
                return;
            }
            else {
                invoiceKeys.push(this.state.selected[i].InvoiceKey);
            }
        }
        if (prelimTotal > 500000) {
            alert("The current invoice selection exceeds our $500,000 online transaction limit. Please select fewer invoices to proceed online, or contact us at AR@boland.com to provide an above-limit payment.");
            return;
        }

        this.props.history.push({
            pathname: '/invoice_payment',
            state: {
                user: this.state.user,
                invoiceKeys: invoiceKeys,
                accountID: this.state.account.accountID
            }
        });
    }

    handleTableChange(type, { page, sizePerPage, sortField, sortOrder }) {
        console.log(this.state);
        if (type == "pagination") {
            this.tableRef.current.selectionContext.selected = [];
            this.setState(() => ({
                selected: []
            }));
        }
        axios.get(`${Constants.apiURL}/api/Payment/invoices`, {
            params: {
                user: this.state.user.username,
                accountID: this.state.account.accountID.trim(),
                page: page,
                pageSize: sizePerPage,
                sortOrder: sortOrder,
                sortField: sortField,
                searchTerm: '',// this.state.searchTerm,
                type: this.state.filterEntityType
            }
        }).then(response => {
            console.log(response);
            if (response.data) {

                //state.bdata = JSON.parse(response.data.data);
                //state.btotalSize = response.data.rowcount;
                this.setState(() => ({
                    page: page,
                    sizePerPage: sizePerPage,
                    sortField: sortField,
                    sortOrder: sortOrder,
                    data: JSON.parse(response.data.data),
                    filteredData: JSON.parse(response.data.data),
                    totalSize: response.data.rowcount,
                    selected: []
                }));
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }

    handleCreditTableChange(type, { page, sizePerPage, sortField, sortOrder }) {
        console.log(this.state);
        if (type == "pagination") {
            this.creditTableRef.current.selectionContext.selected = [];
            this.setState(() => ({
                selectedCredits: []
            }));
        }
        axios.get(`${Constants.apiURL}/api/Payment/payments`, {
            params: {
                user: this.state.user.username,
                accountID: this.state.account.accountID,
                searchTerm: '',// this.state.searchTerm,
                type: this.state.filterEntityType
            }
        }).then(response => {
            console.log(response);
            if (response.data) {
                this.setState(() => ({
                    creditData: JSON.parse(response.data.data),
                    filteredCreditData: JSON.parse(response.data.data),
                    totalSize: response.data.rowcount,
                    selectedCredits: [],
                    selectedCreditIds: []
                }));
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }
    handleApplyCredits() {
        if (this.state.data.length == 0) {
            alert('There are no open ' + this.state.filterEntityType + ' invoices on your account. Please try again after receiving your next invoice.');
            return;
        }
        let creditTotal = 0.0;
        for (let i = 0; i < this.state.selectedCredits.length; i++) {
            creditTotal += this.state.selectedCredits[i].BalanceAmount;
        }
        creditTotal = Number(creditTotal.toFixed(2));

        this.props.history.push({
            pathname: '/apply_credits',
            state: {
                user: this.state.user,
                account: this.state.account,
                credits: this.state.selectedCredits,
                creditTotal: creditTotal,
                entityType: this.state.filterEntityType
            }
        });
    }

    showButton() {
        if (this.state.loading) {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.handleDownloadSelected}>
                Download Selected
            </Button>
        }
    }
    showButtonCredits() {
        if (this.state.creditLoading) {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Loading...</span>
            </Button>
        }
        else {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.handleCreditDownloadSelected}>
                Download Selected
            </Button>
        }
    }

    handleDownloadSelected(event) {

        event.preventDefault();
        if (this.state.selected.length == 0) { return; }
        this.setState({ loading: true });
        let invoiceNums = this.state.selected.reduce(function (str, item) {
            return str + item.DocumentNumber + ",";
        }, '');
        axios.get(`${Constants.apiURL}/api/Payment/download`, {
            params: {
                user: this.state.user.username,
                invoiceNums: invoiceNums
            },
            responseType: "blob"
        }).then(response => {

            this.setState({ loading: false });
            ReactGA.event({
                category: 'Download',
                action: 'Download Selected Invoices',
                label: 'Open Invoice'
            });
            let blob = new Blob([response.data], { type: "application/zip" }),
                downloadUrl = window.URL.createObjectURL(blob),
                filename = "",
                disposition = response.headers["content-disposition"];

            if (disposition && disposition.indexOf("attachment") !== -1) {
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                    matches = filenameRegex.exec(disposition);

                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, "");
                }
            }
            else {
                alert('We are unable to locate the selected document(s). Please email us at AR@boland.com for help with this issue.');
                return;
            }

            let a = document.createElement("a");
            if (typeof a.download === "undefined") {
                window.location.href = downloadUrl;
            } else {
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ loading: false });
            console.log('request failed', response)
        });
    }
    handleCreditDownloadSelected(event) {

        event.preventDefault();
        if (this.state.selectedCredits.length == 0) { return; }
        this.setState({ creditLoading: true });
        let creditNumbers = this.state.selectedCredits.reduce(function (str, item) {
            return str + item.PaymentNumber + ",";
        }, '');
        axios.get(`${Constants.apiURL}/api/Payment/downloadCredits`, {
            params: {
                user: this.state.user.username,
                documentNumbers: creditNumbers
            },
            responseType: "blob"
        }).then(response => {
            ReactGA.event({
                category: 'Download',
                action: 'Download Selected Credits',
                label: 'Open Credits'
            });

            this.setState({ creditLoading: false });

            let blob = new Blob([response.data], { type: "application/zip" }),
                downloadUrl = window.URL.createObjectURL(blob),
                filename = "",
                disposition = response.headers["content-disposition"];

            if (disposition && disposition.indexOf("attachment") !== -1) {
                let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                    matches = filenameRegex.exec(disposition);

                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, "");
                }
            }
            else {
                alert('We are unable to locate the selected document(s). Please email us at AR@boland.com for help with this issue.');
                return;
            }

            let a = document.createElement("a");
            if (typeof a.download === "undefined") {
                window.location.href = downloadUrl;
            } else {
                a.href = downloadUrl;
                a.download = filename;
                document.body.appendChild(a);
                a.click();
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ creditLoading: false });
            console.log('request failed', response)
        });
    }
    downloadCSV(event) {

        this.setState({ downloadingCSV: true });
        axios.get(`${Constants.apiURL}/api/Payment/invoicesCSV`, {
            params: {
                user: this.state.user.username,
                accountID: this.state.account.accountID,
                searchTerm: this.state.searchTerm,
                type: this.state.filterEntityType
            },
            responseType: 'blob'
        }).then(response => {
            console.log(response);
            this.setState({ downloadingCSV: false });
            ReactGA.event({
                category: 'Download',
                action: 'Download Invoice CSV',
                label: 'Open Invoices'
            });
            if (response.data) {
                if (response.data == 'No files found.') return;
                let blob = new Blob([response.data], { type: 'text/csv' }),
                    downloadUrl = window.URL.createObjectURL(blob),
                    filename = "",
                    disposition = response.headers["content-disposition"];

                if (disposition && disposition.indexOf("attachment") !== -1) {
                    let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/,
                        matches = filenameRegex.exec(disposition);

                    if (matches != null && matches[1]) {
                        filename = matches[1].replace(/['"]/g, "");
                    }
                }
                else {
                    alert('We are unable to locate the selected document(s). Please email us at clientportal@boland.com for help with this issue.');
                    return;
                }

                let a = document.createElement("a");
                if (typeof a.download === "undefined") {
                    window.location.href = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                }
                downloadUrl.revokeObjectURL();
            }
        }).catch((response) => {
            // ? Show to user that request is failed
            this.setState({ errors: [response] })
            this.setState({ downloadingCSV: false });
            console.log('request failed', response)
        });
    }
    showCSVButton() {
        if (this.state.downloadingCSV) {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit">
                <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true" />
                <span className="visually-hidden">Downloading...</span>
            </Button>
        }
        else {
            return <Button style={{ backgroundColor: '#1F419B' }} variant="primary" type="submit" onClick={this.downloadCSV}>
                Export as CSV
            </Button>
        }
    }

    render() {
        const { filteredData, totalSize, page, sizePerPage, emptyText, selectedIds, filteredCreditData, selectedCreditIds, emptyCreditText } = this.state;
        const columns = [
            {
                dataField: 'DocumentNumber',
                text: 'Invoice #',
                align: 'center',
                sort:true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'PONumber',
                text: 'PO #',
                align: 'center',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'DocumentDate',
                text: 'Invoice Date',
                align: 'center',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: dateFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'DueDate',
                text: 'Due Date',
                align: 'center',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: dateFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'OriginalAmount',
                text: 'Total Invoice Amount',
                align: 'center',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: currencyFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'BalanceDue',
                text: 'Invoice Balance',
                align: 'center',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: currencyFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'InvoiceStatus',
                text: 'Status',
                align: 'center',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'BuildingName',
                text: 'Building',
                align: 'center',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'OrderNumber',
                text: 'Order Number',
                align: 'center',
                sort: true,
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                },
                formatExtraData: this.state,
                formatter: (cell, row, props, p) => {
                    return <Link to={{
                        pathname: 'view_order_details',
                        state: {
                            user: p.user,
                            input: {
                                BuildingName: row.BuildingName,
                                Id: row.OrderKey,
                                OrderNumber: row.OrderNumber,
                                CreatedDate: row.CreatedDate,
                                PurchaseOrder: row.PurchaseOrder,
                                DisplayID: row.DisplayID,
                                OrderType: row.OrderType
                            }
                        }
                    }}> {cell} </Link>
                }
            }

        ];
        const creditColumns = [
            {
                dataField: 'PaymentNumber',
                text: 'Credit #',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'CreatedOn',
                text: 'Credit Date',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: dateFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'OriginatingAmount',
                text: 'Total Credit Amount',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: creditCurrencyFormat,
                style: {
                    verticalAlign: 'middle'
                }
            },
            {
                dataField: 'BalanceAmount',
                text: 'Credit Balance',
                align: 'center',
                headerStyle: (colum, colIndex) => {
                    return { textAlign: 'center', backgroundColor: '#1F419B', color: 'white' };
                },
                formatter: creditCurrencyFormatBold,
                style: {
                    verticalAlign: 'middle'
                }
            }
        ];
        const selectRow = {
            mode: 'checkbox',
            clickToSelect: true,
            onSelect: this.handleSelect,
            onSelectAll: this.handleSelectAll,
            selected: selectedIds,
            style: { backgroundColor: '#D2D9EB' },
            headerColumnStyle: {
                backgroundColor: '#1F419B'
            }
        };
        const selectCreditRow = {
            mode: 'checkbox',
            clickToSelect: true,
            onSelect: this.handleCreditSelect,
            onSelectAll: this.handleCreditSelectAll,
            selected: selectedCreditIds,
            style: { backgroundColor: '#D2D9EB' },
            headerColumnStyle: {
                backgroundColor: '#1F419B'
            }
        };

        return (
            <div class="open_invoices">
                <SiteMenu user={this.state.user} currentPage='openInvoices' />
                <Form className="mb-3" onSubmit={e => { e.preventDefault(); }}>
                    <Form.Group as={Row} controlId="searchForm" style={{ padding: '10px 15px 0px 15px' }}>

                        <Col md="auto" sm="auto" xs="auto">
                            <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', color: '#1F419B', fontSize: 20 }}>OPEN INVOICES</Form.Label>
                        </Col>
                        <Col width='100%' className="mobile-none"/>
                        <Col className="mobile-none" md="auto" sm="auto" xs="auto" style={{ paddingRight: 0, color: '#00973A', fontWeight: 'bold' }}>
                            <Form.Label style={{ marginBottom: 0, paddingBottom: 3, verticalAlign: 'middle' }}>Company Name:</Form.Label>
                        </Col>
                        <Col md={{span:'auto', order: 1 }} xs={{span:'12', order: 2 }}>
                            <Form.Select onChange={this.handleFilterChange} size="sm" name="filterType" style={{ width: "200px", borderColor: '#00973A' }}>
                                <option value="Boland">Boland</option>
                                <option value="Parklawn">Parklawn</option>
                            </Form.Select>
                        </Col>
                        <Col md={{ span: 'auto', order: 2 }} xs={{ span: '12', order: 3 }}>
                            <div class="form-group position-relative">
                                <Form.Control ref={this.filterText} value={this.state.searchTerm} type="input" size="sm" onChange={this.handleSearchChange} placeholder="Search by invoice, PO number, or building..." style={{ width: "320px" }} />
                                <span class="form-clear">
                                    <CloseButton size="sm" style={{ backgroundColor: 'white', border: 0, height: '0.2em', width: '0.2em' }}
                                        onClick={this.handleClearSearch} />
                                </span>
                            </div>
                        </Col>
                        <Col md={{ span: 'auto', order: 3 }} xs={{ span: 12 ,order: 4 }} >
                            <Button size="sm" style={{ width: 'auto', marginLeft: 0 }} variant="secondary" onClick={this.handleClear}>Clear</Button>
                        </Col>
                        <Col md={{ span:'auto', order: 4 }} xs={{span:12, order: 0 }}>
                            <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle' }}>{this.state.account.accountID} | {this.state.account.accountName}</Form.Label>
                        </Col>
                        <Col md={{ span: 'auto', order: 5 }} xs={{ span: 12, order:1}} style={{ paddingLeft: 0 }}>
                            <Button as={Link} to={{
                                pathname: "/invoice_history",
                                state: {
                                    user: this.state.user,
                                    account: this.state.account
                                }
                            }} style={{ backgroundColor: '#00973A' }} size="sm">
                                View Invoice History
                            </Button>
                        </Col>
                    </Form.Group>
                </Form>
                <div>
                    <BootstrapTable
                        remote
                        id="open_invoices_table"
                        keyField="InvoiceKey"
                        wrapperClasses="table-responsive open_invoices_table"
                        data={filteredData}
                        columns={columns}
                        onTableChange={this.handleTableChange}
                        selectRow={selectRow}
                        noDataIndication={() => <Form.Label>{emptyText}</Form.Label>}
                        hover
                        striped
                        ref={this.tableRef}
                    />
                    <Form.Label md="auto" style={{ paddingLeft: 10, marginTop: 0, marginBottom: 0, paddingTop: 0, verticalAlign: 'middle', fontWeight: 'bold', fontSize: 18 }}>
                        Total selected balance due: ${this.state.selectedTotal.toFixed(2)}
                    </Form.Label>
                    <Form.Group as={Row} controlId="bolandButtons" style={{ padding: '10px 0px 0px 10px', marginRight: 0 }} className="row-btn">
                        <Col md="auto" sm="auto" xs="auto" className="col-btn-first">
                            <Button style={{ backgroundColor: '#00973A' }} onClick={this.handlePaySelected}>
                                Pay Selected
                            </Button>
                        </Col>
                        <Col md="auto" sm="auto" xs="auto" style={{ paddingLeft: 0 }}>
                            {this.showButton()}
                        </Col>
                        <Col md="auto" sm="auto" xs="auto" style={{ paddingLeft: 0 }}>
                            {this.showCSVButton()}
                        </Col>
                    </Form.Group>


                    <Row controlId="searchForm" style={{ padding: '10px 15px 0px 15px' }}>
                        <Col md="auto" sm="auto" xs="auto">
                            <Form.Label style={{ marginBottom: 0, verticalAlign: 'middle', fontWeight: 'bold', color: '#1F419B', fontSize: 20 }}>OPEN CREDITS</Form.Label>
                        </Col>
                    </Row>
                    <Row style={{ paddingRight: '10px' }}>

                        <Col md="10" sm="auto" xs="auto">
                            <Form.Label style={{ fontSize: '15px', marginTop: '-5px', paddingTop: '0px', paddingLeft: '10px', fontStyle: 'italic' }}>Below is a list of open credits on your account. You may submit a request to apply them towards open invoices by selecting desired credits and clicking the green button below. You will then be directed to a new page to indicate which invoice(s) you'd like the credit(s) applied towards.</Form.Label>
                        </Col>
                        <Col style={{ width: '100%' }} />

                        <Col md="auto" sm="auto" xs="auto" style={{ paddingLeft: 0 }}>
                            <Button as={Link} to={{
                                pathname: "/credit_history",
                                state: {
                                    user: this.state.user,
                                    account: this.state.account
                                }
                            }} style={{ backgroundColor: '#00973A' }} size="sm">
                                View Credit History
                            </Button>
                        </Col>
                    </Row>
                    <BootstrapTable
                        remote
                        id="open_invoices_table"
                        keyField="PaymentKey"
                        wrapperClasses="table-responsive open_invoices_table"
                        data={filteredCreditData}
                        columns={creditColumns}
                        onTableChange={this.handleCreditTableChange}
                        selectRow={selectCreditRow}
                        noDataIndication={() => <Form.Label>{emptyCreditText}</Form.Label>}
                        hover
                        striped
                        ref={this.creditTableRef}
                    />
                </div>
                <Form.Group as={Row} controlId="bolandButtons" style={{ padding: '0px 0px 10px 10px', marginRight: 0 }} className="row-btn">
                    <Col md="auto" sm="auto" xs="auto" className="col-btn-first">
                        <Button style={{ backgroundColor: '#00973A', marginRight: '10px' }} variant="primary" type="submit" onClick={this.handleApplyCredits} disabled={this.state.selectedCredits.length == 0}>
                            Apply Selected Credits
                        </Button>
                        {this.showButtonCredits()}
                    </Col>
                </Form.Group>
            </div >
        );
    }
}

export default ViewOpenInvoices;